module.exports = __webpack_public_path__ + "assets/img/driver-btn-2e1a1b34.png";